import { ListItemIcon, ListItemText, MenuItem } from '@mui/material';
import { useCallback } from 'react';
import { Iconify } from 'src/components/iconify';
import { CustomMenu } from '../CustomMenu';
import { MenuProps } from './types';

export const CommandListMenu = ({ onClose, suggestion }: MenuProps) => {
  const { editor, range, clientRect, items, command } = suggestion;

  const selectItem = useCallback(
    async (index: number) => {
      const item = items[index];
      if (item) {
        command(item);
      }
    },
    [command, items],
  );

  if (!items?.length) {
    return null;
  }

  return (
    <CustomMenu
      {...{
        clientRect,
        editor,
        onClose,
        selectItem,
        totalItems: items.length,
      }}
    >
      {({ selectedIndex }) =>
        items.map((item, index) => (
          <MenuItem
            dense
            key={index}
            onClick={() => selectItem(index)}
            selected={selectedIndex === index}
          >
            <ListItemIcon>
              <Iconify icon={item.icon} />
            </ListItemIcon>
            <ListItemText
              secondary={item.description}
              primary={item.title}
              secondaryTypographyProps={{ whiteSpace: 'break-spaces' }}
            />
          </MenuItem>
        ))
      }
    </CustomMenu>
  );
};
